module.exports = __webpack_public_path__ + "static/media/tatu-peba.e51a889b.mp3";